/**
 * Budget transfers (FSD 2.2.5 FIN-F06 V05): the register, the request form and a request's
 * detail with its approval chain. The decision is made in the Approvals Inbox.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_TRANSFER_PERMISSIONS } from '@/modules/budget/transfers/permissions'

export const BUDGET_TRANSFER_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/transfers',
    name: 'budget-transfers',
    component: () => import('@/modules/budget/transfers/TransfersListView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetTransfers',
      permission: BUDGET_TRANSFER_PERMISSIONS.read,
    },
  },
  {
    path: '/budget/transfers/new',
    name: 'budget-transfer-new',
    component: () => import('@/modules/budget/transfers/TransferRequestView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetTransferNew',
      permission: BUDGET_TRANSFER_PERMISSIONS.request,
    },
  },
  {
    path: '/budget/transfers/:id(\\d+)',
    name: 'budget-transfer',
    component: () => import('@/modules/budget/transfers/TransferView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetTransfer',
      permission: BUDGET_TRANSFER_PERMISSIONS.read,
    },
  },
]

export function transfersRoute(companyId?: number | null): string {
  return companyId === undefined || companyId === null
    ? '/budget/transfers'
    : `/budget/transfers?companyId=${companyId}`
}

export function transferRoute(id: number): string {
  return `/budget/transfers/${id}`
}

export function transferNewRoute(companyId?: number | null): string {
  return companyId === undefined || companyId === null
    ? '/budget/transfers/new'
    : `/budget/transfers/new?companyId=${companyId}`
}
